module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.6c860f93.woff2";